var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a', {
    staticClass: "d-md-none",
    attrs: {
      "href": "https://secure.donus.org/withcan/pay/step1?_gl=1*1csn9b9*_ga*MTA5ODMyNDAzLjE3MjE4MTAwODU.*_ga_1KFQVNYJMP*MTc0Mjk2Mzc5OS4yMi4xLjE3NDI5NjU5ODYuNTkuMC4w",
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.item.mobile,
      "alt": ""
    }
  })], 1), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-card', {
    staticClass: "bottom-banner",
    attrs: {
      "tile": "",
      "flat": "",
      "img": _vm.item.image
    }
  }, [_c('v-container', [_c('h2', {
    staticClass: "bottom-banner__title font-aggro",
    class: _vm.item.white ? 'white--text' : ''
  }, [_c('span', {
    staticClass: "primary"
  }, [_vm._v("WITH-CAN,")]), _vm._v(" 변화의 연결고리 "), _c('br'), _vm._v(" 세상을 바꾸는 힘, 함께할 때 시작됩니다. ")]), _c('v-btn', {
    staticClass: "mt-20 mt-md-40",
    attrs: {
      "href": "https://secure.donus.org/withcan/pay/step1?_gl=1*1csn9b9*_ga*MTA5ODMyNDAzLjE3MjE4MTAwODU.*_ga_1KFQVNYJMP*MTc0Mjk2Mzc5OS4yMi4xLjE3NDI5NjU5ODYuNTkuMC4w",
      "target": "_blank",
      "color": "primary",
      "large": "",
      "rounded": "pill"
    }
  }, [_c('span', {
    staticClass: "font-size-18 font-size-md-20 font-aggro mb-n2"
  }, [_vm._v("위드캔복지재단과 좋은 변화 시작하기")]), _c('v-icon', {
    staticClass: "ml-10",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }